const state = {
  pathParams: null,
  globalUserInfo: null,
}
const mutations = {
  SET_PATH_PARAMS: (state, payload) => {
    state.pathParams = payload
    sessionStorage.setItem('jumpParams', JSON.stringify(payload))
  },
  SET_GLOBAL_USER: (state, payload) => {
    state.globalUserInfo = payload
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
